/* Pure — no React, no browser. Given a /api/health/detailed snapshot,
   returns an ordered array of { key, title, message } warnings. Empty
   array means the deploy is healthy from a config standpoint. */
export function deriveWarnings(snap) {
  if (!snap || typeof snap !== "object") return [];
  const out = [];
  const integ = snap.integrations || {};
  const boot = snap.bootstrap || {};
  const migs = snap.migrations || {};
  const seed = snap.seed || {};
  const dbInfo = snap.db || {};

  if (dbInfo.ok === false) {
    out.push({
      key: "db-unreachable",
      title: "Database",
      message: "MongoDB ping failed — auth, progress and admin flows will error.",
    });
  }
  if (boot.ok === false) {
    out.push({
      key: "bootstrap-failed",
      title: "Bootstrap",
      message: boot.last_error
        ? `Startup init did not complete: ${boot.last_error}`
        : "Startup init has not completed — indexes, migrations, or admin seed may be missing.",
    });
  }
  if (seed.admin_seeded === false) {
    out.push({
      key: "admin-seed-missing",
      title: "Admin account",
      message: "No admin user is present — check ADMIN_EMAIL / ADMIN_PASSWORD env on this deploy.",
    });
  }
  if (typeof migs.pending_count === "number" && migs.pending_count > 0) {
    out.push({
      key: "migrations-pending",
      title: "Migrations",
      message: `${migs.pending_count} migration${migs.pending_count > 1 ? "s" : ""} pending — schema is not on the latest version.`,
    });
  }
  if (integ.stripe_enabled === false) {
    out.push({
      key: "stripe-disabled",
      title: "Stripe",
      message: "STRIPE_SECRET_KEY not configured — Pro upgrades and team billing are disabled.",
    });
  } else if (integ.stripe_webhook_secret_configured === false) {
    out.push({
      key: "stripe-webhook-secret-missing",
      title: "Stripe webhook",
      message: "STRIPE_WEBHOOK_SECRET is not set — renewals, cancellations and invoice syncs won't reach the backend.",
    });
  }
  if (integ.email_enabled === false) {
    out.push({
      key: "email-disabled",
      title: "Email (Resend)",
      message: "RESEND_API_KEY not configured — verification, password-reset and team-invite emails cannot be sent.",
    });
  }

  return out;
}
